// R18: A login/identity boundary cancels requests before private caches are reused.
let controller = new AbortController();
let revision = 0;
const listeners = new Set<() => void>();

export const getAuthSession = () => ({ revision, signal: controller.signal });
export const onAuthSessionChange = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
export const resetAuthSession = () => {
  revision += 1;
  controller.abort();
  controller = new AbortController();
  listeners.forEach(listener => listener());
};
